import React, { useCallback, useState } from 'react';
import { CloseIcon, InfoFilled } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { dataTestId } from './constants';
import { ClickableStyled, WrapperStyled } from './styled';
export const Toast = React.memo(({ message, hasDismiss = true, hasLeadingIcon = true, onDismiss }) => {
    const [isVisible, setIsVisible] = useState(true);
    const handleClose = useCallback(() => {
        setIsVisible(false);
        onDismiss?.();
    }, [onDismiss]);
    if (!isVisible) {
        return null;
    }
    return (React.createElement(WrapperStyled, null,
        React.createElement(FlexWrapper, null,
            hasLeadingIcon && (React.createElement(FlexWrapper, { mr: INDENT.xxxs },
                React.createElement(SVGIcon, { type: InfoFilled, size: ICON_SIZE.xs, pathFill: colorCoreWhite1000 }))),
            React.createElement(FlexWrapper, { mr: INDENT.xxxs },
                React.createElement(RegularTextLevel4, { color: colorCoreWhite1000 }, message))),
        React.createElement(FlexWrapper, null, hasDismiss && (React.createElement(ClickableStyled, { onClick: handleClose, "data-testid": dataTestId },
            React.createElement(SVGIcon, { type: CloseIcon, size: ICON_SIZE.xs, pathFill: colorCoreWhite1000 }))))));
});
Toast.displayName = 'Toast_component';
